<script setup>
import { computed } from 'vue'
// 레거시 나의강의실(study/index.php, reTest.php, history.php)의 안내 상자. 문구·강조 색은 레거시와 같다(blue = strong, red = .red01).
const props = defineProps({ kind: { type: String, required: true, validator: value => ['current', 'retake', 'ended'].includes(value) } })
const b = text => ({ text, tone: 'blue' }), r = text => ({ text, tone: 'red' })
const NOTICES = {
  current: { title: '학습 주의사항', icon: '/images/study/icon_study.png', items: [
    ['순차학습으로 진행되며, ', r('1일 최대 8차시까지만'), ' 학습이 가능합니다.'],
    ['중간평가, 과제는 ', r('최종제출 후에는 재응시 불가능'), '합니다(', b('1회만 응시 가능'), ').'],
    ['최종평가는 ', r('응시 제한시간이 있으며,'), ' 응시 도중 접속종료를 하더라도 ', r('계속 시간이 흘러갑니다.')],
    ['최종평가는 학습기간 내에 응시 하신 분들 중 미수료 인원, 종료일 4일 후 4일간 ', b('1일 최대 1회'), ' 재응시 가능합니다.'],
    ['점수확인은 ', b('학습종료일이 지난 후, 1주일 이내'), '에 확인할 수 있습니다(주말 및 공휴일 제외).'],
  ] },
  retake: { title: '재응시 주의사항', icon: '/images/study/icon_study.png', items: [
    ['학습기간 내에 최종평가 응시 하신 분들 중 미수료 인원, 종료일 4일 후 4일간 ', r('1일 최대 1회'), ' 재응시 가능'],
    ['1일 최대 1회 09시~20시까지 재응시 가능합니다.'],
  ] },
  ended: { title: '안내사항', icon: '/images/study/icon_end.png', items: [
    ['점수확인은 학습종료일이 지난 후, ', b('1주일'), ' 이내에 확인할 수 있습니다.'],
    ['수료증 발급은 학습종료일이 지난 후, ', r('1주일'), ' 이내에 출력 가능합니다.'],
    ['수료결과보고서(교육증빙자료)는 학습종료일이 지난 후, ', b('2주~3주'), ' 이내에 교육담당자 메일로 발송됩니다.'],
    ['미수료로 인한 재수강 문의는 ', b('학습자 회사 내부 교육담당자'), '에게 확인 부탁드립니다.'],
  ] },
}
const notice = computed(() => NOTICES[props.kind])
</script>
<template>
  <section class="study-notice" :aria-labelledby="`study-notice-${kind}`">
    <img :src="notice.icon" alt="" width="80">
    <div>
      <h2 :id="`study-notice-${kind}`">{{ notice.title }}</h2>
      <ul>
        <li v-for="(parts, index) in notice.items" :key="index"><template v-for="(part, at) in parts" :key="at"><strong v-if="typeof part !== 'string'" :class="part.tone">{{ part.text }}</strong><template v-else>{{ part }}</template></template></li>
      </ul>
    </div>
  </section>
</template>
<style scoped>
/* 레거시 #noticeArea: 빗금 테두리(bg_study01.png border-image), 아이콘 80px, 제목 19px #1b2531, 항목 14px/20px #455467, 파란 네모 글머리(bg_notice01.png). */
.study-notice{display:flex;align-items:center;gap:30px;margin:26px 0;padding:2.4em 2em;border:6px solid #dfe5ee;border-image:url('/images/study/bg_study01.png') 5 repeat;background:#fff;text-align:left}
.study-notice>img{flex:none;width:80px;height:auto;margin-left:9px}
.study-notice h2{margin:0;color:#1b2531;font-size:19px;font-weight:700;line-height:1.4}
.study-notice ul{margin:10px 0 0;padding:0;list-style:none}
.study-notice li{padding-left:20px;background:url('/images/study/bg_notice01.png') 0 4px no-repeat;color:#455467;font-size:14px;line-height:20px;word-break:keep-all;overflow-wrap:anywhere}
.study-notice li+li{margin-top:2px}
.study-notice strong{font-weight:400}
.study-notice .blue{color:#2b7ee7}
.study-notice .red{color:red}
@media (max-width:640px){.study-notice{flex-direction:column;align-items:flex-start;gap:14px;padding:1.4em 1.2em}.study-notice>img{width:60px;margin:0}}
</style>
